import deepmerge from 'deepmerge'

export const merge = (acc: any, item: any) => {
  return !item ? acc : deepmerge(acc, item, {clone: false})
}
